import { useMutation } from "@tanstack/react-query";
import { createTransaccion, updateTransaccion } from "../api";

export const useCreateTransaccion = () => {
  const query = useMutation({
    mutationKey: ['useCreateTransaccion'],
    mutationFn: createTransaccion,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useUpdateTransaccion = () => {
  const query = useMutation({
    mutationKey: ['updateTransaccion'],
    mutationFn: updateTransaccion,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};